import { QRCodeSVG } from "qrcode.react";

// The brand mark is a real, scannable QR code pointing at the marketing site,
// rendered as crisp SVG so it stays sharp at any size / on retina displays.
export const BRAND_URL = "https://www.growithevent.com";

export default function BrandQR({ size = 32, className = "" }) {
  return (
    <span
      className={`bg-white border border-zinc-200 rounded-md inline-flex items-center justify-center shrink-0 overflow-hidden ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <QRCodeSVG
        value={BRAND_URL}
        size={size}
        level="L"
        marginSize={2}
        bgColor="#ffffff"
        fgColor="#000000"
        title="Growithevent — www.growithevent.com"
      />
    </span>
  );
}
